import React, { createContext, useContext } from 'react';

const SiteTakeoffContext = createContext(null);

export const SiteTakeoffProvider = ({ value, children }) => (
  <SiteTakeoffContext.Provider value={value}>
    {children}
  </SiteTakeoffContext.Provider>
);

export const useSiteTakeoff = () => {
  const ctx = useContext(SiteTakeoffContext);
  if (!ctx) {
    throw new Error('useSiteTakeoff must be used within a SiteTakeoffProvider');
  }
  return ctx;
};

export default SiteTakeoffContext;
